import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Scissors } from 'lucide-react';

function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  const locationPathname = [
    '/academy',
    '/about-academy',
    '/mission-academy',
    '/programs-academy',
    '/packages-academy',
    '/training-center-academy',
  ];

  const handleErrorClick = () => {
    if (locationPathname.includes(location.pathname)) {
      navigate('/academy');
    } else {
      navigate('/');
    }
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        {/* Scissor Animation */}
        <div className="relative mb-8">
          <Scissors 
            className="w-24 h-24 text-yellow-500 mx-auto animate-bounce" 
            strokeWidth={1.5} 
          />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 border-4 border-dashed border-yellow-500/30 rounded-full animate-spin" />
        </div>

        {/* Main Text */}
        <h1 className="text-8xl font-bold text-white mb-4 font-serif">
          4
          <span className="inline-block mx-2 animate-pulse">
            <Scissors className="w-16 h-16 text-yellow-500" />
          </span>
          4
        </h1>

        {/* Barber Pole Divider */}
        <div className="flex justify-center mb-6">
          <div className="w-32 h-2 bg-gradient-to-r from-red-500 via-white to-blue-500 rounded-full animate-pulse" />
        </div>

        <h2 className="text-3xl font-bold text-white mb-4">
          Oops! Page Not Found
        </h2>

        <p className="text-gray-400 mb-8 text-lg">
          Looks like this haircut hasn't been invented yet! 
          Our master barbers are still perfecting this style.
        </p>

        {/* CTA Button */}
        <button 
          onClick={() => handleErrorClick()}
          className="bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-3 rounded-full font-bold transition-all duration-300 transform hover:scale-105 flex items-center mx-auto space-x-2"
        >
          <span>Back to Main Chair</span>
          <Scissors className="w-5 h-5" />
        </button>

        {/* Decorative Elements */}
        <div className="mt-12 flex justify-center space-x-8 text-yellow-500/20">
          <Scissors className="w-8 h-8 transform -rotate-45" />
          <Scissors className="w-8 h-8" />
          <Scissors className="w-8 h-8 transform rotate-45" />
        </div>
      </div>

      {/* Background Pattern */}
      <div className="fixed inset-0 z-[-1] opacity-5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,215,0,0.1)_1px,transparent_1px)] bg-[length:20px_20px]" />
      </div>
    </div>
  )
}

export default NotFound